<rask-tree-selector
    [rule]="rule"
    [placeholder]="placeholder"
    class="cell"
    [items]="values"
    (change)="onTreeSelectionEvent($event)"
    [comparePredicate]="comparePredicate">
</rask-tree-selector>
